var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{ref:"popupEl",class:{
		Popup__root: true,
	},attrs:{"size":_vm.size}},[(_vm.title)?_c('div',[_c('h2',{staticClass:"Popup__heading"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('div',{ref:"slotEl"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }